import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    SHARE: "اشتراک گذاری با",
    TAGS: "برچسب‌ها",
    PUBLISH_DATE: "تاریخ انتشار",
    SUGGESTED_NEWS: "اخبار پیشنهادی",
    SEE_MORE: "مشاهده بیشتر",
    COPIED: "لینک با موفقیت کپی شد",
    BREADCRUMB: (news) => [
      { title: "اخبار", link: "/news" },
      { title: news?.["title"]?.value ?? "جزییات خبر" },
    ],
  },
  [LOCALES.EN]: {
    SHARE: "Share with",
    TAGS: "Tags",
    SUGGESTED_NEWS: "Suggested news",
    PUBLISH_DATE: "Published",
    SEE_MORE: "See More",
    COPIED: "Link Copied Successfully.",
    BREADCRUMB: (news) => [
      { title: "News", link: "/news" },
      { title: news?.["title"]?.value ?? "News Details" },
    ],
  },
};

export default translation;
